import React from 'react';
import { SearchItem } from './components/SearchItem';
import { ComponentWrapper } from '../ComponentWrapper';
import collapse from './assets/collapse.svg';
import expand from './assets/expand.svg';
import './SearchTree.scss';
import { searchTreeCss } from './utils';
import { Icon } from '../Icon';
export const SearchTree = ({ list, selectedId, onSelect, header, isCollapsed, toggleCollapsed, className, overrideCss, }) => {
    const { searchTree, searchTreeCollapseButton, searchTreeHeader, searchTreeItem, searchTreeList, } = searchTreeCss({ className, isCollapsed, overrideCss });
    const handleChange = (id) => {
        if (onSelect) {
            onSelect(id);
        }
    };
    return (React.createElement("div", { className: searchTree },
        header ? (React.createElement("div", { className: searchTreeHeader },
            React.createElement(ComponentWrapper, { component: header }))) : null,
        React.createElement("ul", { className: searchTreeList }, list.map((item) => (React.createElement("li", { key: item.id, className: searchTreeItem },
            React.createElement(SearchItem, Object.assign({}, item, { onClick: () => handleChange(item.id), isActive: selectedId === item.id, className: className, overrideCss: overrideCss })))))),
        React.createElement("button", { className: searchTreeCollapseButton, type: "button", onClick: toggleCollapsed },
            React.createElement(Icon, { source: isCollapsed ? expand : collapse }))));
};
//# sourceMappingURL=SearchTree.js.map